import { Puck} from "@measured/puck";
import React from "react";
import {config} from "./puck.config";

import "@measured/puck/puck.css";




// Render the Puck editor
export function Editor({ title, content, setContent }) {
  // Disable the iframe so the preview shares the parent document's
  // stylesheet (Tailwind v4 is imported once in styles.css and isn't
  // injected into Puck's iframe, which made border/radius/shadow utilities
  // only "appear" once content was published and viewed elsewhere).
  return (
    <Puck
      config={config}
      title={title}
      data={content || { root: { props: { title } } }}
      onPublish={setContent}
      iframe={{ enabled: false }}
    />
  );
}
